import { Button, Divider } from '@material-ui/core';
import { FieldArray, Form, Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import CategoryItem from './CategoryItem';
import CategoriesEditableItem from './CategoriesEditableItem';
// Here is an example of a form with an editable list.
// Next to each input are buttons for insert and remove.
// If the list is empty, there is a button to add an item.

const AddButtonContainer = styled.div`
  padding-top : 10px;
  padding-left: 10px;
`;

const ContainerFooter = styled.div`
    width:100%;
    display:flex;
    height:40px;
    justify-content:flex-end;
    padding-right:20px;    
    border-top-width:1px;
    align-items:center;
`;


const ButtonContainer = styled.div`
    padding:20px;
    padding-left:10px;
    padding-right:10px;

`;

const Container = styled.div`
    min-height:400px;
    display:grid;
    grid-template-rows:1fr 60px;
    

`;

const ContentContainer = styled.div`
    
    padding-bottom:20px;

`;

const NoCategoriesText = styled.div`
height:300px;
display:flex;
align-items:center;
justify-content:center;
font-family: Roboto;
font-size: 15px;
font-weight: 400;
`;


const CategoriesForm = ({ context, formProps, arrayHelpers }) => {
    return (

        <Container>
            {formProps.values.categories &&
                <>
                    <ContentContainer>
                        {formProps.values.categories.length === 0 &&
                            <NoCategoriesText>
                                <center>
                                    There are no procedure categories in this function. <br />
                                    Start by creating a new category for each type of procedure (for example, SWPP or EDP).
                                </center>
                            </NoCategoriesText>
                        }
                        {formProps.values.categories.map((category, index) => (
                            formProps.values.editableIndex === index ?
                                <CategoriesEditableItem key={index}
                                    {...formProps.values.categories[index]}
                                    onDelete={() => {
                                        formProps.setFieldValue(`categories.${index}.delete`, true);
                                        formProps.setFieldValue(`editableIndex`, null);
                                    }}
                                    onCancel={() => formProps.setFieldValue(`editableIndex`, null)}
                                    onConfirm={values => {
                                        formProps.setFieldValue(`categories.${index}`, values);
                                        formProps.setFieldValue(`editableIndex`, null);
                                    }}
                                />
                                :
                                <CategoryItem key={index} formProps={formProps} arrayHelpers={arrayHelpers} index={index} context={context} />

                        ))}
                    </ContentContainer>
                    <div>
                        <ContainerFooter>
                            <ButtonContainer>
                                <Button variant="outlined" color="primary" onClick={() => {
                                    context.closeCategoriesDialog();
                                }}>Cancel</Button>
                            </ButtonContainer>

                            <ButtonContainer>
                                <Button disabled={formProps.values.editableIndex !== null || formProps.dirty === false} variant="contained" color="primary" onClick={() => {
                                    context.updateFunctionCategories(formProps.values.categories, context.selectedFunctionDetails.id);
                                    context.closeCategoriesDialog();
                                }}>Save</Button>
                            </ButtonContainer>
                        </ContainerFooter>
                    </div>
                </>
            }
        </Container>
    )
};
export default CategoriesForm;